import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../utils/styledComponent';
import theme from '../../theme';

const VARIANTS = {
  am: {
    background: theme.colors.badgeAm,
    color: theme.colors.badgeAmText,
  },
  pm: {
    background: theme.colors.badgePm,
    color: theme.colors.badgePmText,
  },
  warning: {
    background: theme.colors.warning,
    color: theme.colors.white,
  },
  muted: {
    background: theme.colors.whiteOverlay,
    color: 'inherit',
  },
};

const StyledSpan = styledComponent('span', {
  padding: theme.spacing.smallBadgePadding,
  borderRadius: theme.radii.pill,
  ...theme.typography.badge,
  display: 'inline-block',
});

function Badge({ variant, children }) {
  const variantStyles = VARIANTS[variant] || {};
  return <StyledSpan style={variantStyles}>{children}</StyledSpan>;
}

Badge.propTypes = {
  variant: PropTypes.oneOf(Object.keys(VARIANTS)).isRequired,
  children: PropTypes.node.isRequired,
};

export default Badge;
